<template>
  <div id="store">
    <div class="filterConditionContainer">
      <el-card class="box-card">
        <div class="filterCondition" >
          <div class="searchIcon">
            <i class="el-icon-search"></i>
          </div>
          <el-form :inline="true" :model="filterForm" class="filterForm" label-width="120px">
            <el-form-item :label="$t('filters.region')" >
              <el-select v-model="filterForm.regionNo" multiple :placeholder="$t('filters.chooseRegion')" @visible-change="resetFilters()">
                <el-option
                  v-for="item in regionOptions"
                  :key="item.itemKey"
                  :label="item.itemValue"
                  :value="item.itemKey">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('filters.province')" >
              <el-select v-model="filterForm.provinceNo" multiple :placeholder="$t('filters.chooseProvince')" @visible-change="resetFilters()">
                <el-option
                  v-for="item in provinceOptions"
                  :key="item.itemKey"
                  :label="item.itemValue"
                  :value="item.itemKey">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('filters.city')" >
              <el-select v-model="filterForm.cityNo" multiple :placeholder="$t('filters.chooseCity')" @visible-change="getRangeList()">
                <el-option
                  v-for="item in cityOptions"
                  :key="item.itemKey"
                  :label="item.itemValue"
                  :value="item.itemKey">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('filters.reseller')" >
              <el-select v-model="filterForm.resellerNo" multiple :placeholder="$t('filters.chooseReseller')" @visible-change="resetFilters()">
                <el-option
                  v-for="item in resellerOptions"
                  :key="item.itemKey"
                  :label="item.itemValue"
                  :value="item.itemKey">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('filters.subReseller')" >
              <el-select v-model="filterForm.subReseller" multiple :placeholder="$t('filters.chooseSubReseller')" @visible-change="resetFilters()">
                <el-option
                  v-for="item in subResellerOptions"
                  :key="item.itemKey"
                  :label="item.itemValue"
                  :value="item.itemKey">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('filters.storeType')" >
              <el-select v-model="filterForm.storeType" :placeholder="$t('filters.chooseStoreType')">
                <el-option
                  v-for="item in storeTypeOptions"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('filters.publicAccountType')" >
              <el-select v-model="filterForm.publicAccountType" :placeholder="$t('filters.choosePublicAccountType')">
                <el-option
                  v-for="item in publicAccountTypeOptions"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('filters.publicAccountName')" >
              <el-input v-model="filterForm.publicAccountName" :placeholder="$t('filters.enterPublicAccountName')"></el-input>
            </el-form-item>
            <el-form-item :label="$t('filters.doorName')"  >
            <span @click="onChooseDoor">
              <el-input v-model="filterForm.door" :placeholder="$t('filters.chooseDoorName')"></el-input>
            </span>
            </el-form-item>
            <el-form-item label="门店编号">
              <el-input v-model="filterForm.posId" :placeholder="$t('filters.choosePOSID')"></el-input>
            </el-form-item>
            <el-form-item :label="$t('filters.bindStatus')" >
              <el-select v-model="filterForm.bindStatus" :placeholder="$t('filters.chooseBindStatus')">
                <el-option
                  v-for="item in bindStatusOptions"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <el-row type="flex" class="row-bg" justify="space-between">
            <el-col :span="8">
              <div class="filterBtns">
                <el-button type="primary" @click="onSearch(true)">{{ $t('search') }}</el-button>
                <el-button type="primary" @click="onReset">{{ $t('reset') }}</el-button>
                <router-link :to=" { path:'/wo/doorEdit'}" target="_blank">
                  <el-button type="primary">{{ $t('add') }}</el-button>
                </router-link>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="filterBtns filterBtnsRight">
                <input type="file" ref="importData" @change="importData" id="importFileInput">
                <el-button type="primary" @click="$refs.importData.click()">{{ $t('import') }}</el-button>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-card>
      <pickDoor v-model="filterForm.posId" :filterForm="this.filterForm" ref='PickDoor'/>
    </div>
    <div class="tableContainer">
      <el-card class="box-card">
        <div class="tableBox">
          <div class="orangeIcon">
            <i class="el-icon-s-order"></i>
          </div>
        </div>
        <div style="margin-top: 20px">
          <el-table
            :data="tableData"
            style="width: 100%">
            <el-table-column
              fixed
              prop="doorName"
              :label="$t('store.doorName1')"
              width="280">
            </el-table-column>
            <el-table-column
              fixed
              prop="doorAddress"
              :label="$t('store.doorAddress')"
            >
            </el-table-column>
            <el-table-column
              prop="posId"
              label="门店编号"
              width="120">
            </el-table-column>
            <el-table-column
              prop="storePhase"
              label="Store Phase"
              width="120">
            </el-table-column>
            <el-table-column
              prop="publicAccountType"
              :label="$t('filters.publicAccountType')"
              width="120">
            </el-table-column>
            <el-table-column
              prop="publicAccountName"
              :label="$t('filters.publicAccountName')"
              width="120">
            </el-table-column>
            <el-table-column
              prop="regionName"
              :label="$t('filters.region')"
              width="120">
            </el-table-column>
            <el-table-column
              prop="provinceName"
              :label="$t('filters.province')"
              width="120">
            </el-table-column>
            <el-table-column
              prop="cityName"
              :label="$t('filters.city')"
              width="120">
            </el-table-column>
            <el-table-column
              prop="locateName"
              :label="$t('filters.locate')"
              width="120">
            </el-table-column>
            <el-table-column
              prop="storeType"
              :label="$t('filters.storeType')"
              width="120">
            </el-table-column>
            <el-table-column
              prop="resellerName"
              :label="$t('filters.reseller')"
              width="120">
            </el-table-column>
            <el-table-column
              prop="subReseller"
              :label="$t('filters.subReseller')"
              width="120">
            </el-table-column>
            <el-table-column
              prop="createTime"
              :label="$t('newSurvey.createTime')"
              width="120">
            </el-table-column>
            <el-table-column
              fixed="right"
              :label="$t('operation')"
              width="120">
              <template slot-scope="scope">
                <el-button @click="bindPublicAccount(scope.row)" type="text" size="small">{{ $t('bindPublicAccount') }}</el-button>
                <el-button @click="seePublicAccount(scope.row)" type="text" size="small">{{ $t('seePublicAccount') }}</el-button>
                <router-link :to=" { path:'/wo/doorEdit', query: {id: scope.row.id} }" target="_blank">
                  <el-button type="text" size="small">{{ $t('edit') }}</el-button>
                </router-link>
                <el-button @click="deleteStore(scope.row)" type="text" size="small">{{ $t('delete') }}</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagingBox">
            <el-pagination
              background
              @current-change="currentChange"
              :current-page="tableConfig.current"
              layout="total, prev, pager, next, jumper"
              :total="total">
            </el-pagination>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import Cookies from 'js-cookie'
import PickDoor from '../../components/pickDoor'
export default {
  name: 'Store',
  components: {
    pickDoor: PickDoor,
  },
  data: function () {
    return {
      storeTypeOptions: [], // 门店类型
      publicAccountTypeOptions: [], // 公众号类型
      bindStatusOptions: [], // 绑定状态
      regionOptions: [],
      provinceOptions: [],
      cityOptions: [],
      resellerOptions: [],
      subResellerOptions: [],
      dialogTableVisible: false,
      initFilterForm: {
        provinceNo: '', // 省份
        regionNo: '', // 区域
        cityNo: '', // 城市
        resellerNo: '', // 客户
        subReseller: '', // 二级客户
        posId: '', // posId
        door: '', // 门店名
        publicAccountType: '', // 公众号类型
        storeType: '', // 门店类型
        publicAccountName: '', // 公众号名称
        bindStatus: '', // 绑定状态
      },
      matchList: [],
      successNum: 0,
      filterForm: {},
      tableData: [],
      tableConfig: {
        current: 1,
        size: 10
      },
      total: 0
    }
  },
  mounted () {
    this.onReset()
    this.getRangeList()
  },
  computed: {
  },
  methods: {

    // 绑定公众号
    bindPublicAccount: function (row) {

    },
    // 查看公众号
    seePublicAccount: function (row) {

    },
    // 编辑门店
    editStore: function (row) {
      this.$router.push({ path: '/wo/doorEdit', query: { id: row.id }})
    },
    // 新增门店
    addStore: function () {
      this.$router.push({ path: '/wo/doorEdit' })
    },
    // 删除门店
    deleteStore: function (row) {

    },
    importData: async function ({ target }) {
      let formData = new FormData()
      formData.append('file', target.files[0])
      let res = await window.instance.post(window.surveyUrl + '/door/import', formData)
      document.getElementById('importFileInput').value = ''
      res = res.data
      if (res.code === 200) {
        this.$message.success(res.message)
      }
    },
    onChooseDoor: function () {
      this.$refs.PickDoor.openDialog()
    },
    resetFilters: function () {
      this.getRangeList()
    },
    getRangeList: async function (clear) {
      let filterParams = {
        'cityNo': this.filterForm.cityNo,
        'resellerNo': this.filterForm.resellerNo,
        'subReseller': this.filterForm.subReseller,
        'provinceNo': this.filterForm.provinceNo,
        'regionNo': this.filterForm.regionNo,
      }
      let submitParams = this.$tool.formatArrayToString(filterParams)
      if (clear) {
        submitParams = {}
      }
      let res = await window.instance.post(window.retailogUrl + '/account/common', submitParams)
      console.log('res', res)
      res = res.data.data
      this.regionOptions = res.regionList
      this.provinceOptions = res.provinceList
      this.cityOptions = res.cityList
      this.resellerOptions = res.resellerList
      this.subResellerOptions = res.subResellerList
    },
    onSearch: async function (resetPage) {
      if (resetPage) {
        this.tableConfig.current = 1
      }
      const params = this.$tool.formatArrayToString(this.filterForm)
      let res = await this.$api.survey_api.listDoor(_.assign(params, this.tableConfig))
      this.tableData = res.list
      this.total = res.total
    },
    onReset: function () {
      this.filterForm = _.cloneDeep(this.initFilterForm)
      this.getRangeList(true)
    },
    downLoadTemplate: function () {
      this.$tool.exportFile({
        url: this.$api.survey_api.base + '/door/importTemplate',
        method: 'get'
      })
    },
    matchSearch: async function ({ target }) {
      let formData = new FormData()
      formData.append('file', target.files[0])
      let res = await this.$api.survey_api.doorParse(formData)
      if (res) {
        // 匹配门店成功,获取匹配的门店列表
        this.matchList = res.list
        let successNum = 0
        _.each(this.matchList, (data) => {
          if (data.name && data.retailinkName) {
            successNum++
          }
        })
        this.successNum = successNum
        this.dialogTableVisible = true
      }
    },
    exportData: async function () {
      let { data, fileName } = await this.$tool.exportFile({
        method: 'post',
        url: this.$api.survey_api.base  + '/door/export',
        data: this.$tool.formatArrayToString(this.filterForm)
      })
      console.log(data, fileName)
    },
    disableStore: function (row) {
      const tipContent = this.$t('store.disableDoor') + '?'
      const tip = this.$t('tip')
      this.$confirm(tipContent, tip, {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      })
        .then(async () => {
          let res = await this.$api.survey_api.delDoor(row.id)
          if (res) {
            await this.onSearch(false)
            this.$message.success("操作成功！")
          } else {
            // this.$message.warning(res.message)
          }
        })
        .catch(_ => {})
    },
    currentChange: function (index) {
      this.tableConfig.current = index
      this.onSearch(false)
    },
    hubdoorFormatter: function (row) {
      return row.isHubDoor ? this.$t('yes') : this.$t('no')
    },
    exportResult: async function () {
      this.dialogTableVisible = false
      const submitResult = []
      _.each(this.matchList, (data) => {
        submitResult.push({
          'posId': data.posId,
          'result': !!data.name,
          'result2': !!data.retailinkName
        })
      })
      let { data, fileName } = await this.$tool.exportFile({
        method: 'post',
        url: this.$api.survey_api.base + '/door/exportresult',
        data: submitResult
      })
      console.log(data, fileName)
    },
    onClose: function () {
      this.dialogTableVisible = false
      this.matchList = []
      this.successNum = 0
    },
  }
}
</script>

<style lang="sass" scoped>
  a
    margin-left: 10px
  .filterConditionContainer
    margin: 40px 20px 20px 20px
  .tableContainer
    margin: 40px 20px
  input[type=file]
    display: none
</style>



// WEBPACK FOOTER //
// src/pages/wo/doorManage.vue